import { inputElementModel } from "../../../../models/common/inputElement.model";
import InputElementComponent from "../../../common/InputElementComponent";

import DeleteIcon from "@mui/icons-material/Delete";

export const CreditCardsListComponent = ({ props }) => {
  const { creditCardsList, selectedCreditCardId } = props;
  const { handleSelectCreditCard, handleDeleteCreditCard } = props.functions;

  const getCreditCardRadioInputElement = (creditCard) => {
    const inputElementProps = {
      ...inputElementModel,
      id: creditCard ? creditCard.id : "-1",
      name: "creditCard",
      value: creditCard ? creditCard.id : "-1",
      checked: creditCard ? selectedCreditCardId === creditCard.id : selectedCreditCardId === "-1", // Track selected card
      onChange: handleSelectCreditCard, // Handle change event
      type: "radio",
      removeDefaultStyle: true,
      className: "flexRow gap10",
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  return (
    <div className="flexColumn gap5 ">
      <div className="flexRow gap20 padding10 lightBorder">
        {getCreditCardRadioInputElement()}
        <label className="flexRow gap10" htmlFor={"-1"}>
          <span>הוספת אמצעי תשלום חדש</span>
        </label>
      </div>
      {/* registered credit cards */}
      {creditCardsList.map((creditCard) => (
        <div className="flexRow gap20 padding10 lightBorder justifySpaceBetween">
          <div className="flexRow gap20">
            {getCreditCardRadioInputElement(creditCard)}
            <label className="flexRow gap10" htmlFor={creditCard.id}>
              <span>{creditCard.fourDigits}</span>
              <span>{`${creditCard.expireMonth}/${creditCard.expireYear}`}</span>
            </label>
          </div>

          <div
            onClick={() => {
              handleDeleteCreditCard(creditCard);
            }}
          >
            <DeleteIcon />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CreditCardsListComponent;
